'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var errors_appError = require('./appError.js');
var errors_AISErrorCodes = require('./AISErrorCodes.js');
var errors_errorCodes = require('./errorCodes.js');
require('../tslib.es6-cd939937.js');

function formatAISError(error, response) {
    if (response === void 0) { response = null; }
    var message = '';
    var name = 'Unknown error';
    var netCode = null;
    var aisCode = null;
    var errCode = errors_errorCodes.ErrorCodes.NET_ERR;
    if (response === null || response === void 0 ? void 0 : response.statusText) {
        name = message = response.statusText;
    }
    if (response === null || response === void 0 ? void 0 : response.status) {
        netCode = response.status;
    }
    if (error instanceof TypeError) {
        errCode = errors_errorCodes.ErrorCodes.APP_ERR;
        message = error.message || message;
        name = error.name || name;
    }
    else if (error instanceof Error) {
        errCode = netCode && netCode < 500 ? errors_errorCodes.ErrorCodes.AIS : errors_errorCodes.ErrorCodes.NET_ERR;
        message = error.message || message;
        name = error.name || name;
    }
    else if (error) { //AMS response
        errCode = errors_errorCodes.ErrorCodes.AIS;
        if (error === null || error === void 0 ? void 0 : error.userMessage) {
            message = error.userMessage;
        }
        else if (error === null || error === void 0 ? void 0 : error.message) {
            message = error.message;
        }
        else if (error === null || error === void 0 ? void 0 : error.displayMessage) {
            message = error.displayMessage;
        }
        else if (error === null || error === void 0 ? void 0 : error.developerMessage) {
            message = error.developerMessage;
        }
        else if (error === null || error === void 0 ? void 0 : error.detailMessage) {
            message = error.detailMessage;
        }
        if (error === null || error === void 0 ? void 0 : error.code) {
            aisCode = error === null || error === void 0 ? void 0 : error.code;
        }
        else if (error === null || error === void 0 ? void 0 : error.resultCode) {
            aisCode = error === null || error === void 0 ? void 0 : error.resultCode;
        }
        else if (error === null || error === void 0 ? void 0 : error.statusCode) {
            aisCode = error === null || error === void 0 ? void 0 : error.statusCode;
        }
        if (errors_AISErrorCodes.AISErrorsCodes[parseInt(aisCode)]) {
            name = errors_AISErrorCodes.AISErrorsCodes[parseInt(aisCode)];
        }
    }
    return new errors_appError.AppError(errCode, name, "" + (aisCode ? '[' + aisCode + '] ' : '') + (message ? message + '' : '') + " " + (netCode ? '(' + netCode + ')' : ''), {
        aisCode: aisCode,
        netCode: netCode,
        errCode: errCode,
        name: name,
        message: message,
        response: response,
        origError: error
    });
}

exports.formatAISError = formatAISError;
